import { useLayoutEffect, useState } from 'react';

/** Nine columns. Laptops clear it, phones on their side don't. */
export const TABLE_MIN_WIDTH = 600;

/** Pass the element itself, not a ref, so we re-measure when it mounts. */
export function useWideEnough(
  box: HTMLElement | null,
  minWidth: number = TABLE_MIN_WIDTH
): boolean {
  const [wide, setWide] = useState(true);

  useLayoutEffect(() => {
    if (!box) {
      return undefined;
    }
    const check = () => setWide(box.clientWidth >= minWidth);
    check();
    // Not in jsdom. The first check is all the tests need.
    if (typeof ResizeObserver === 'undefined') {
      return undefined;
    }
    const observer = new ResizeObserver(check);
    observer.observe(box);
    return () => observer.disconnect();
  }, [box, minWidth]);

  return wide;
}
